import { criptografar, decriptografar } from 'services/utils/encryption';
import { AuthStatus } from 'contexts/auth/auth_context';
import { getByIdentificationUser } from 'modules/users/apis/user.api';
import { IUser } from 'modules/auth/interfaces/storage.interface';
import { IPermissionUserContext } from 'contexts/auth/permission_context';

const TOKEN_KEY = 'mt_login_token';
const TOKEN_API_INTERNA_KEY = 'api_interna_token';
const USER_DATA = 'user_data';
const USUARIO_JA_ACEITOU_TERMO_USO = 'usuario_ja_aceitou_termo_uso';
const PERMISSION_KEY = 'permissions';

export const authService = {
  getCodeFromUrl(): string | null {
    const params = new URLSearchParams(window.location.search);
    return params.get('code');
  },

  getMtLoginTokeLocalStorage(): string | null {
    try {
      const encryptedToken = localStorage.getItem(TOKEN_KEY);
      return encryptedToken ? JSON.parse(decriptografar(encryptedToken)) : null;
    } catch (error) {
      console.error('Error retrieving token', error);
      this.removeToken();
      return null;
    }
  },

  setMtLoginTokeLocalStorage(token: string): void {
    try {
      localStorage.setItem(TOKEN_KEY, criptografar(JSON.stringify(token)));
    } catch (error) {
      console.error('Error storing token', error);
    }
  },

  setTokenAPIInterna(token: string): void {
    try {
      localStorage.setItem(
        TOKEN_API_INTERNA_KEY,
        criptografar(JSON.stringify(token)),
      );
    } catch (error) {
      console.error('Error storing token api interna', error);
    }
  },

  setPermissionsLocalStorage(granularPermissions: IPermissionUserContext): void {
    try {
      localStorage.setItem(
        PERMISSION_KEY,
        criptografar(JSON.stringify(granularPermissions)),
      );
    } catch (error) {
      console.error('Error storing granular permissions', error);
    }
  },

  getPermissionsLocalStorage(): IPermissionUserContext | null {
    try {
      const encryptedData = localStorage.getItem(PERMISSION_KEY);
      return encryptedData
        ? JSON.parse(decriptografar(encryptedData))
        : null;
    } catch (error) {
      console.error('Error retrieving granular permissions', error);
      return null;
    }
  },

  getTokenAPIInterna(): string | null {
    try {
      const encryptedToken = localStorage.getItem(TOKEN_API_INTERNA_KEY);
      return encryptedToken ? JSON.parse(decriptografar(encryptedToken)) : null;
    } catch (error) {
      console.error('Error retrieving token api interna', error);
      this.removeToken();
      return null;
    }
  },

  getUserDataLocalStorage(): IUser | null {
    try {
      const encryptedData = localStorage.getItem(USER_DATA);
      return encryptedData ? JSON.parse(decriptografar(encryptedData)) : null;
    } catch (error) {
      console.error('Error retrieving user data', error);
      return null;
    }
  },

  setUserDataLocalStorage(userData: IUser): void {
    try {
      localStorage.setItem(USER_DATA, criptografar(JSON.stringify(userData)));
    } catch (error) {
      console.error('Error storing user data', error);
    }
  },

  removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_DATA);
  },

  removerItensLocalStorage(): void {
    localStorage.clear();
  },

  setUsuarioJaAceitouTermoUsoLocalStorage(
    UsuarioAceitouTermoUso: boolean,
  ): void {
    try {
      localStorage.setItem(
        USUARIO_JA_ACEITOU_TERMO_USO,
        UsuarioAceitouTermoUso ? 'true' : 'false',
      );
    } catch (error) {
      console.error('Error storing user data', error);
    }
  },

  getUsuarioJaAceitouTermoUsoLocalStorage(): boolean | null {
    try {
      const ValorItem = localStorage.getItem(USUARIO_JA_ACEITOU_TERMO_USO);

      if (ValorItem === null) return null;

      return ValorItem === 'true';
    } catch (error) {
      console.error('Error retrieving user data', error);
      return null;
    }
  },

  async checkUserStatusByCpf(identification: string): Promise<{
    success: boolean;
    status: AuthStatus;
    userInfo?: IUser;
    message?: string;
  }> {
    try {
      const DadosUsuario: any = await getByIdentificationUser(identification);

      if (DadosUsuario?.isRegisterBlocked) {
        return {
          success: false,
          status: AuthStatus.userBlocked,
          message: 'User is blocked',
        };
      }

      if (!DadosUsuario?.isRegisterActive) {
        return {
          success: false,
          status: AuthStatus.userInactive,
          message: 'User is inactive',
        };
      }

      const { userStatusList } = DadosUsuario;

      const userDataStorage: IUser = {
        ...DadosUsuario,
        statusList: userStatusList,
      };

      return {
        success: true,
        status: AuthStatus.userAuthorized,
        userInfo: userDataStorage,
      };
    } catch (error: any) {
      if (error.response?.data?.statusCode === 404) {
        return {
          success: false,
          status: AuthStatus.userNotFound,
          message: 'User not found',
        };
      }
      return {
        success: false,
        status: AuthStatus.requestError,
        message: 'Request error : ' + error.message,
      };
    }
  },
};
